var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:{'px-0': _vm.dense},attrs:{"grid-list-lg":"","fluid":""}},[_c('fieldset',{attrs:{"disabled":_vm.disabled}},[_c('v-layout',{class:{'px-0': _vm.dense, 'mx-0': _vm.dense},attrs:{"wrap":""}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }